// extracted by css-extract-rspack-plugin
export default {"cls1":"NewLine-cls1_PHW","cls2":"NewLine-cls2_l5V NewLine-cls1_PHW"};